import { useEffect } from 'react';

import useResolvedZipCode from '@/hooks/useResolvedZipCode';
import useAppointmentStore from '@/store/AppointmentStore';
import { useLocationSearch } from '../../SelectAgent/api/getLocationSearch';

const usePreloadedAgentSearchLocation = (enabled: boolean) => {
  const resolvedZipCode = useResolvedZipCode();
  const preloadedAgentSearchLocation = useAppointmentStore(
    (state) => state.preloadedAgentSearchLocation,
  );
  const setPreloadedAgentSearchLocation = useAppointmentStore(
    (state) => state.setPreloadedAgentSearchLocation,
  );

  const {
    data: initialLocationResults = [],
    isFetched: hasFetchedInitialLocation,
  } = useLocationSearch(enabled ? resolvedZipCode : '');

  useEffect(() => {
    if (!enabled || !resolvedZipCode) {
      if (preloadedAgentSearchLocation) {
        setPreloadedAgentSearchLocation(undefined);
      }
      return;
    }

    if (!hasFetchedInitialLocation) {
      return;
    }

    const matchedLocation = initialLocationResults.find(
      (location) => location.zipCode === resolvedZipCode,
    );

    if (preloadedAgentSearchLocation?.id === matchedLocation?.id) {
      return;
    }

    if (!matchedLocation && !preloadedAgentSearchLocation) {
      return;
    }

    setPreloadedAgentSearchLocation(matchedLocation);
  }, [
    enabled,
    hasFetchedInitialLocation,
    initialLocationResults,
    preloadedAgentSearchLocation,
    resolvedZipCode,
    setPreloadedAgentSearchLocation,
  ]);
};

export default usePreloadedAgentSearchLocation;
